
const UPDATE_PORT = (data) => {
    return { type: 'UPDATE_PORT', port: data }
}
export { 
    UPDATE_PORT
}